export default "__VITE_ASSET__Ho25MLVV__"